import { render, staticRenderFns } from "./BaseNotificationCount.vue?vue&type=template&id=e8540ca2&scoped=true&"
import script from "./BaseNotificationCount.vue?vue&type=script&lang=js&"
export * from "./BaseNotificationCount.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotificationCount.vue?vue&type=style&index=0&id=e8540ca2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8540ca2",
  null
  
)

export default component.exports